var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 150,
    viewBox: "0 0 220 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3851_1193136",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 0,
    width: 150,
    height: 150
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    width: 150,
    height: 150,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3851_1193136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2305 106.779C46.2305 103.558 47.0617 100.683 48.7242 98.1553C50.3867 95.6271 52.607 93.6605 55.3852 92.2553C61.3247 89.3501 67.2971 87.11 73.3023 85.535C79.3086 83.961 85.9091 83.174 93.1039 83.174C100.3 83.174 106.9 83.961 112.905 85.535C118.912 87.11 124.885 89.3501 130.824 92.2553C133.602 93.6605 135.823 95.6271 137.485 98.1553C139.148 100.683 139.979 103.558 139.979 106.779V111.179C139.979 113.694 139.055 115.906 137.209 117.813C135.362 119.72 133.12 120.674 130.484 120.674H55.7242C53.0888 120.674 50.8477 119.751 49.0008 117.904C47.1539 116.056 46.2305 113.814 46.2305 111.179V106.779ZM150.063 120.674C150.849 119.24 151.448 117.713 151.86 116.094C152.273 114.476 152.479 112.837 152.479 111.179V106.01C152.479 101.908 151.475 97.998 149.466 94.2803C147.457 90.5636 144.607 87.3745 140.916 84.7131C145.107 85.3381 149.086 86.3053 152.852 87.6147C156.618 88.9251 160.212 90.4735 163.634 92.26C166.863 93.9829 169.357 96.0136 171.115 98.3521C172.873 100.69 173.752 103.242 173.752 106.01V111.179C173.752 113.814 172.829 116.056 170.982 117.904C169.135 119.751 166.894 120.674 164.259 120.674H150.063ZM93.1039 73.0771C87.0883 73.0771 81.9388 70.9355 77.6555 66.6521C73.3721 62.3678 71.2305 57.2178 71.2305 51.2021C71.2305 45.1865 73.3721 40.037 77.6555 35.7537C81.9388 31.4693 87.0883 29.3271 93.1039 29.3271C99.1195 29.3271 104.27 31.4693 108.554 35.7537C112.837 40.037 114.979 45.1865 114.979 51.2021C114.979 57.2178 112.837 62.3678 108.554 66.6521C104.27 70.9355 99.1195 73.0771 93.1039 73.0771ZM147.07 51.2021C147.07 57.2178 144.928 62.3678 140.645 66.6521C136.361 70.9355 131.212 73.0771 125.196 73.0771C124.491 73.0771 123.593 72.9969 122.504 72.8365C121.413 72.6761 120.516 72.5001 119.812 72.3084C122.276 69.3449 124.171 66.0574 125.495 62.4459C126.817 58.8344 127.479 55.0844 127.479 51.1959C127.479 47.3063 126.804 43.5704 125.454 39.9881C124.104 36.4068 122.223 33.11 119.812 30.0975C120.709 29.7766 121.606 29.5683 122.504 29.4725C123.401 29.3756 124.298 29.3271 125.196 29.3271C131.212 29.3271 136.361 31.4693 140.645 35.7537C144.928 40.037 147.07 45.1865 147.07 51.2021Z",
    fill: "#E8E8E8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsEmptyState);
export default __webpack_public_path__ + "static/media/groups_empty_state.e2cdaca6c8a88c80227832d2af1d8a43.svg";
export { ForwardRef as ReactComponent };